import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { GIVESENDGO_URL } from "../lib/api";

const links = [
    { to: "/", label: "Home" },
    { to: "/about", label: "The Film" },
    { to: "/get-involved", label: "Get Involved" },
    { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        setOpen(false);
    }, [location.pathname]);

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "backdrop-blur-xl bg-[#ECE8DF]/85 border-b border-black/10"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
                <Link
                    to="/"
                    data-testid="navbar-logo"
                    className="flex items-center gap-3 group"
                >
                    <span className="w-2 h-2 bg-blood"></span>
                    <span className="font-accent uppercase tracking-[0.25em] text-lg sm:text-xl text-neutral-900 group-hover:text-blood transition-colors">
                        State<span className="text-blood">.</span>of
                        <span className="text-blood">.</span>Deception
                    </span>
                </Link>

                <nav className="hidden md:flex items-center gap-8">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={`nav-${l.label.replace(/\s+/g, "-").toLowerCase()}`}
                            className={({ isActive }) =>
                                `font-mono text-base uppercase tracking-[0.2em] transition-colors ${
                                    isActive
                                        ? "text-blood"
                                        : "text-neutral-600 hover:text-neutral-900"
                                }`
                            }
                            end={l.to === "/"}
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    <a
                        href={GIVESENDGO_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="nav-donate-btn"
                        className="ml-4 font-accent uppercase tracking-widest text-base py-3 px-6 bg-blood text-white hover:bg-bloodHover transition-colors border border-blood"
                    >
                        Fund the Film
                    </a>
                </nav>

                <button
                    data-testid="mobile-menu-toggle"
                    onClick={() => setOpen(!open)}
                    className="md:hidden text-neutral-900 p-2"
                    aria-label="Toggle menu"
                >
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {open && (
                <div
                    data-testid="mobile-menu"
                    className="md:hidden bg-[#ECE8DF]/95 backdrop-blur-xl border-t border-black/10"
                >
                    <div className="px-6 py-8 flex flex-col gap-6">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                data-testid={`mobile-nav-${l.label.replace(/\s+/g, "-").toLowerCase()}`}
                                className={({ isActive }) =>
                                    `font-accent uppercase tracking-[0.25em] text-2xl ${
                                        isActive ? "text-blood" : "text-neutral-900"
                                    }`
                                }
                                end={l.to === "/"}
                            >
                                {l.label}
                            </NavLink>
                        ))}
                        <a
                            href={GIVESENDGO_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="mobile-nav-donate-btn"
                            className="font-accent uppercase tracking-widest text-lg py-4 px-6 bg-blood text-white text-center"
                        >
                            Fund the Film
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Navbar;
